import React from "react";
import { useTranslation } from "react-i18next";
import { useRillContext } from "../rill/RillReact/share/base";

function View(props) {
  const { t } = useTranslation("auth");
  const { locals } = useRillContext();

  const { query } = locals;
  const { redirect } = query;
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt={t("maintenance.logoAlt")}
      />
      <div className="frame">
        <div className="Maintenance">
          <div className="head">{t("maintenance.title")}</div>
          <div className="body">
            <p>{t("maintenance.description")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const Maintenance = (app) => {
  app.get("/maintenance", ({ res }) => (res.body = <View />));
};

export default Maintenance;
